import React, { useState } from 'react';
import { Modal, Box, Button, TextField, Typography, IconButton, InputAdornment, Alert } from '@mui/material';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';

const DeleteHotel = ({ open, handleClose, hotel, onDelete, loading }) => {
  const [adminPassword, setAdminPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);

  const handleConfirm = () => {
    onDelete(adminPassword);
    setAdminPassword('');
  };

  const handleCancel = () => {
    setAdminPassword('');
    handleClose();
  };

  return (
    <Modal open={open} onClose={handleCancel}>
      <Box sx={{ ...modalStyle }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1 }}>
          <WarningAmberIcon color="error" />
          <Typography variant="h6" component="h2" color="error">
            Eliminar Hotel Permanentemente
          </Typography>
        </Box>

        <Alert severity="error" sx={{ mb: 2 }}>
          Esta acción es <strong>irreversible</strong>. Se eliminará el hotel{' '}
          <strong>{hotel?.name}</strong> y todos sus datos relacionados: habitaciones,
          reservas, clientes, empleados, facturas, gastos, conversaciones de WhatsApp, etc.
        </Alert>

        <Typography variant="body2" sx={{ mb: 1 }}>
          Para confirmar, ingresa tu contraseña de administrador:
        </Typography>

        <TextField
          label="Contraseña de Administrador"
          type={showPassword ? 'text' : 'password'}
          fullWidth
          margin="normal"
          value={adminPassword}
          onChange={(e) => setAdminPassword(e.target.value)}
          autoComplete="new-password"
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <IconButton onClick={() => setShowPassword(!showPassword)} edge="end">
                  {showPassword ? <Visibility /> : <VisibilityOff />}
                </IconButton>
              </InputAdornment>
            )
          }}
        />

        <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 2, mt: 2 }}>
          <Button variant="outlined" onClick={handleCancel} disabled={loading}>
            Cancelar
          </Button>
          <Button
            variant="contained"
            color="error"
            onClick={handleConfirm}
            disabled={!adminPassword || loading}
          >
            {loading ? 'Eliminando...' : 'Eliminar Definitivamente'}
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};

const modalStyle = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 440,
  bgcolor: 'background.paper',
  borderRadius: '12px',
  boxShadow: 24,
  p: 4
};

export default DeleteHotel;
